<template>
  <nav v-if="showNav">
    <v-toolbar
      style="background-color: #ffffff"
      class="elevation-0"
      height="80px"
    >
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        class="grey--text hidden-md-and-up"
      ></v-app-bar-nav-icon>

      <v-flex class="ml-2 d-flex align-center">
        <div class="mt-2 mb-1 mr-2" v-if="false">
          <v-img
            lazy-src="../assets/logo.png"
            max-height="80"
            max-width="60"
            src="../assets/logo.png"
          ></v-img>
        </div>
        <div class="font-weight-light title ml-1">
          <span class="font-weight-black teks-effect-toright">KEPOIN</span>
          <div
            class="subtitle-2 mt-n1 grey--text text--darken-2 font-weight-regular hidden-sm-and-down"
          >
            KENALI POTENSI INVESTASI KAB LUMAJANG
          </div>
        </div>
      </v-flex>

      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
            x-small
          :dark="isDarkMode"
          class="font-weight-bold custom-btn"
          @click="switchOn = 'beranda'"
          :class="{ 'btn-switch-on': switchOn === 'beranda' }"
          plain
          elevation="0"
          color="gray darken-1"
          route
          to="/home"
          v-if="currentUser === null"
        >
          <span>Beranda</span>
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
            x-small
          :dark="isDarkMode"
          class="font-weight-bold custom-btn"
          @click="switchOn = 'komoditi'"
          :class="{ 'btn-switch-on': switchOn === 'komoditi' }"
          plain
          elevation="0"
          color="gray darken-1"
          route
          to="/public-komoditi"
          v-if="currentUser === null"
        >
          <span>Komoditas & Umkm</span>
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
            x-small
          :dark="isDarkMode"
          class="font-weight-bold custom-btn"
          @click="switchOn = 'dda'"
          :class="{ 'btn-switch-on': switchOn === 'dda' }"
          plain
          elevation="0"
          color="gray darken-1"
          route
          to="/public-infrastruktur"
          v-if="currentUser === null"
        >
          <span>Infrastruktur</span>
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
            x-small
          :dark="isDarkMode"
          class="font-weight-bold custom-btn"
          @click="switchOn = 'iki'"
          :class="{ 'btn-switch-on': switchOn === 'iki' }"
          plain
          elevation="0"
          color="gray darken-1"
          route
          to="/public-umkm-siap-bermitra"
          v-if="currentUser === null"
        >
          <span>UMKM Siap Bermitra</span>
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
            x-small
            :dark="isDarkMode"
            class="font-weight-bold custom-btn"
            @click="switchOn = 'insentif'"
            :class="{ 'btn-switch-on': switchOn === 'insentif' }"
            plain
            elevation="0"
            color="gray darken-1"
            route
            to="/public-insentif"
            v-if="currentUser === null"
        >
          <span>How To Invest</span>
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
            x-small
            :dark="isDarkMode"
            class="font-weight-bold custom-btn"
            @click="switchOn = 'publikasi'"
            :class="{ 'btn-switch-on': switchOn === 'publikasi' }"
            plain
            elevation="0"
            color="gray darken-1"
            route
            to="/public-e-library"
            v-if="currentUser === null"
        >
          <span>Publikasi</span>
        </v-btn>
      </v-toolbar-items>

      <v-toolbar-items class="d-flex align-center justify-center">
        <div>
          <v-img
            lazy-src="../assets/dpmptsp-lumajang.png"
            max-height="50"
            max-width="130"
            src="../assets/dpmptsp-lumajang.png"
          ></v-img>
        </div>
      </v-toolbar-items>
    </v-toolbar>

    <v-navigation-drawer app
                         class="hidden-md-and-up"
                         v-model="drawer"
                         v-if="! this.$vuetify.breakpoint.mdAndUp" >
      <v-layout column>
        <div class="d-flex flex-row justify-center align-center mt-3 mb-2">
          <v-img
            lazy-src="../assets/logo.png"
            max-height="50"
            max-width="40"
            src="../assets/logo.png"
          ></v-img>
        </div>
        <div class="font-weight-light title ml-1 text-center">
          <span class="font-weight-black teks-effect-toright">KEPOIN</span>
          <div
              class="narrow-letter-spacing subtitle-2 mt-n3 grey--text text--darken-2 font-weight-regular hidden-sm-and-down"
          >
            KENALI POTENSI INVESTASI KAB LUMAJANG
          </div>
        </div>

      </v-layout>

      <v-divider></v-divider>
      <v-list>
        <v-list-item route to="/home">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-subtitle>Beranda</v-list-item-subtitle>
        </v-list-item>
        <v-list-item route to="/public-komoditi">
          <v-list-item-icon>
            <v-icon>mdi-cow</v-icon>
          </v-list-item-icon>
          <v-list-item-subtitle>Komoditas & Umkm</v-list-item-subtitle>
        </v-list-item>
        <v-list-item route to="/public-infrastruktur">
          <v-list-item-icon>
            <v-icon>mdi-gas-station</v-icon>
          </v-list-item-icon>
          <v-list-item-subtitle>Infrastruktur</v-list-item-subtitle>
        </v-list-item>
        <v-list-item route to="/public-umkm-siap-bermitra">
          <v-list-item-icon>
            <v-icon>mdi-store</v-icon>
          </v-list-item-icon>
          <v-list-item-subtitle>UMKM Siap Bermitra</v-list-item-subtitle>
        </v-list-item>
        <v-list-item route to="/public-insentif">
          <v-list-item-icon>
            <v-icon>mdi-checklist</v-icon>
          </v-list-item-icon>
          <v-list-item-subtitle>How To Invest</v-list-item-subtitle>
        </v-list-item>
        <v-list-item route to="/public-e-library">
          <v-list-item-icon>
            <v-icon>mdi-book-open-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-subtitle>Publikasi</v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      drawer: false,
      isDarkMode: false,
      switchOn: false,

      menu_berita_agenda: [
        { icon: "", title: "Berita", route: "/public_berita", visible: true },
        { icon: "", title: "Agenda", route: "/public_agenda", visible: true },
      ],
      menu_informasi: [
        {
          icon: "",
          title: "Tenaga Kerja",
          route: "/public_tenaga_kerja",
          visible: true,
        },
        {
          icon: "",
          title: "Kontraktor",
          route: "/public_cv_pt",
          visible: true,
        },
      ],
    };
  },
  computed: {
    showNav() {
      const excludePaths = [
          "/login", "/register",
        "/verifikasi-login-link",
        "/register-webinar",
        "/registration-masukkan-otp",
        "/registation-active",
        "/reset-success",

        "/reset-atur-ulang",
        "/reset-masukkan-otp",
        "/reset-masukkan-otp-password"
      ];

      const currentPath = this.$route.path;

      return !excludePaths.some((path) => currentPath.startsWith(path));
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    signIn() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
  },
};
</script>



<style scoped>
.teks-effect-toright {
  font-size: 0px;
  font-weight: bolder;
  letter-spacing: 3px;
  text-transform: uppercase;
  text-align: center;

  background: linear-gradient(to right, #69da6f, #10400e);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradient 5s ease infinite;

  text-transform: uppercase;
  background-image: linear-gradient(
    -225deg,
    #1e5e17 0%,
    #44107a 29%,
    #ff1361 67%,
    #218319 100%
  );

  background-size: auto auto;
  background-clip: border-box;
  background-size: 200% auto;
  color: #fff;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: textclip 2s linear infinite;
  display: inline-block;
  font-size: 38px;
}

@keyframes textclip {
  to {
    background-position: 200% center;
  }
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}

.waviy {
  position: relative;
  font-weight: bolder;
}
.waviy span {
  position: relative;
  display: inline-block;
  font-size: 40px;
  color: #0f3009;
  text-transform: uppercase;
  animation: flip 2s infinite;
  animation-delay: calc(0.2s * var(--i));
}
@keyframes flip {
  0%,
  80% {
    transform: rotateY(360deg);
  }
}

.custom-btn {
  color: #000000; /* Warna teks */
  background-color: #ffffff; /* Warna latar belakang */
  border-radius: 1px; /* Sudut tombol */
  letter-spacing: 0px;
}

.custom-btn:hover {
  background-color: rgb(
    235,
    243,
    235
  ); /* Warna latar belakang tipis saat hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Bayangan saat dihover */
}

.btn-switch-on {
  background-color: rgb(
    214,
    235,
    214
  ); /* Warna latar belakang tipis saat hover */
  border-radius: 5px;
}

</style>